import { LoadingWrapper } from "@vapor/react-contrib-tax-compliance";
import { Stack } from "@vapor/react-material";
import type { GovernmentAgencyType } from "../../../../../core/api/use-get-tax-submission-detail/TaxSubmissionDetailDTO";
import { useGetTaxSubmissionDetail } from "../../../../../core/api/use-get-tax-submission-detail/useGetTaxSubmissionDetail";
import { TaxSubmissionDetailSummary } from "../tax-submission-detail-summary/TaxSubmissionDetailSummary";
import { TaxSubmissionDetail } from "../tax-submission-detail/TaxSubmissionDetail";

interface TaxSubmissionDetailDrawerProps {
    onClickPreviewOutcome: (
        availablesOutcomeTypes: string[],
        governmentAgencyType: GovernmentAgencyType,
        taxSubmissionId: string,
        selectedOutcomeType: string,
        taxPayer?: string,
    ) => unknown;
    onClickF24Preview: (
        taxSubmissionId: string,
        taxPayerId: string,
        taxPayerName: string,
        taxPayerPosition: number,
        delegationPosition?: number,
    ) => unknown;
    revokeTaxPayers: boolean;
    taxSubmissionId: string;
    onUpdateData: () => void;
}

export const TaxSubmissionDetailDrawer: React.FC<
    TaxSubmissionDetailDrawerProps
> = ({
    taxSubmissionId,
    onUpdateData,
    onClickPreviewOutcome,
    onClickF24Preview,
    revokeTaxPayers,
}) => {
    const {
        isFetching: loadingGetTaxSubmissionDetail,
        data: dataGetTaxSubmissionDetail,
    } = useGetTaxSubmissionDetail({
        id: taxSubmissionId,
    });

    return (
        <Stack direction="column" spacing={4}>
            <LoadingWrapper
                loading={loadingGetTaxSubmissionDetail}
                variant="skeleton-list"
                skeletonProps={{ rowsNumber: 10, title: false }}
            >
                {dataGetTaxSubmissionDetail && (
                    <>
                        <TaxSubmissionDetailSummary
                            taxSubmissionDetail={dataGetTaxSubmissionDetail}
                        />
                        <TaxSubmissionDetail
                            taxSubmissionDetail={dataGetTaxSubmissionDetail}
                            loading={loadingGetTaxSubmissionDetail}
                            onTaxSubmissionUpdate={onUpdateData}
                            onClickPreviewOutcome={onClickPreviewOutcome}
                            onClickF24Preview={onClickF24Preview}
                            revokeTaxPayers={revokeTaxPayers}
                        />
                    </>
                )}
            </LoadingWrapper>
        </Stack>
    );
};
